import { motion } from "framer-motion";

const SuccessIllustration = () => {
  return (
    <div className="w-full h-full relative">
      <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-rose-100"></div>
      <motion.svg
        width="400"
        height="400"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 m-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.circle
          cx="250"
          cy="250"
          r="150"
          fill="#ECFDF5"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 100,
            damping: 15,
            delay: 0.3,
          }}
        />
        <motion.circle
          cx="250"
          cy="250"
          r="150"
          fill="none"
          stroke="#C71F2C"
          strokeWidth="8"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
        />

        <motion.path
          d="M180 250L230 300L320 200"
          stroke="#C71F2C"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 0.8,
            delay: 1.2,
            ease: "easeInOut",
          }}
        />

        {/* Optional: Add some celebratory particles */}
        <motion.g initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2.0, duration: 0.5 }}>
          <circle cx="160" cy="160" r="8" fill="#C71F2C" />
          <circle cx="340" cy="160" r="8" fill="#C71F2C" />
          <circle cx="160" cy="340" r="8" fill="#C71F2C" />
          <circle cx="340" cy="340" r="8" fill="#C71F2C" />
          <circle cx="150" cy="250" r="5" fill="#C71F2C" />
          <circle cx="350" cy="250" r="5" fill="#C71F2C" />
          <circle cx="250" cy="150" r="5" fill="#C71F2C" />
          <circle cx="250" cy="350" r="5" fill="#C71F2C" />
        </motion.g>
      </motion.svg>
    </div>
  );
};

export default SuccessIllustration;
